'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'hand-wave';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e1a7';
var svgPathData = 'M392.2 67.4L391 58.9c-2.5-17.6-16.3-31.4-33.9-33.9l-8.5-1.2c-13.1-1.9-22.2-14-20.4-27.2s14-22.2 27.2-20.4l8.5 1.2c38.7 5.5 69.1 36 74.7 74.7l1.2 8.5c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4zM217.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7l0-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40l0 176.3c0 60.2-27.9 116.9-75.5 153.7-50.8 39.2-115.5 49.7-173.6 32.7-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9c-83.9-83.9-130.2-130.2-139.1-139.1-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9 .1 .1 46.6 46.6c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L89.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L261.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L137.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L325.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L217.4 70.6zM28.6 360.2c13.1-1.9 25.3 7.2 27.2 20.4l1.2 8.5c2.5 17.6 16.3 31.4 33.9 33.9l8.5 1.2c13.1 1.9 22.2 14 20.4 27.2s-14 22.2-27.2 20.4l-8.5-1.2C45.4 465 15 434.6 9.5 395.9l-1.2-8.5c-1.9-13.1 7.2-25.3 20.4-27.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHandWave = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;